module.exports = __webpack_public_path__ + "img/coc-logo-fsc.7f887997.jpeg";